import React from 'react';
import BaseApi from "../../utils/BaseApi";
import {CircularProgress} from "@mui/joy";
import Typography from "@mui/joy/Typography";
import RouteSubordinateList from "./RouteSubordinateList";


class RouteSubordinateLists extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            subordinates: null,
        };
    }

    async componentDidMount() {
        await this.retrieveSubordinates();
    }

    async retrieveSubordinates() {
        const url = 'subscriber/descendants/';
        const api = new BaseApi();
        let response = await api.get(
            url,
            {
                page_size: 10000,
            }
        );
        this.setState({
            subordinates: response.data.results
        })
    }

    render() {
        if (!this.state.subordinates) {
            return (<CircularProgress/>)
        }
        return (
            <>
                <Typography
                    level={'h1'}
                >
                    Маршруты коллег
                </Typography>
                {this.state.subordinates.map((subordinate) => {
                    return(
                        <>
                            <Typography
                                level={'h2'}
                            >
                                {subordinate.user.last_name} {subordinate.user.first_name}
                            </Typography>
                            <RouteSubordinateList
                                subscriber={subordinate}
                            />
                        </>
                    )
                })}

            </>
        )
    }
}

export default RouteSubordinateLists